import { BaseModel } from "./base";

export enum ArticuloTransferenciaTipo {
    Envio,
    Recepcion,
}

export type ArticuloTransferencia = BaseModel & {
    fecha: string,
    tipo: ArticuloTransferenciaTipo,
    items: ArticuloTransferenciaItem[]
}

export type ArticuloTransferenciaItem = {
    id: string,
    articuloId: string,
    articuloNombre: string,
    articuloCodigo: string,
    cantidad: number
}